import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { logRavenException } from '../../../utils/ravenWrapperUtil';
const PORTAL_CONFIG_URL = '/forecasting/v1/portal-configuration';
const getPortalConfig = () => {
  return http.get(PORTAL_CONFIG_URL).catch(error => {
    logRavenException(error, 'Fetch portal config');
    return null;
  });
};
export const GET_FORECAST_DEAL_AMOUNT_CONFIG = registerQuery({
  fieldName: 'portalConfig',
  async fetcher() {
    const response = await getPortalConfig();
    return response === null || response === void 0 ? void 0 : response.forecastDealAmountConfiguration;
  }
});